import { useState, useLayoutEffect, Fragment } from 'react';
import ServiceDirectoryMenu from '../../components/ServiceDirectoryMenu/ServiceDirectoryMenu';
import useMediaQuery from '@mui/material/useMediaQuery';
import {
  ButtonsMenuContainer,
  MediumHeightDivider,
  SmallHeightDivider,
  CardContainer,
  StyledButtonOutlined,
} from '../../theme/Styles';
import { Row, RowBodyDivider } from '../../theme/Styles';
import { useDispatch } from 'react-redux';
import { UpdateAppSubHeaderTitle } from '../../redux/actions/UiActions';
import {
  Container,
  MetricsContentDivider,
  MetricsTextContainer,
  MetricsTitle,
  MetricsValue,
} from './styles/MyDeskStyles';
import ButtonGroup from '@mui/material/ButtonGroup';
import MyProfile from './subViews/myProfile/MyProfile';
import MyRequests from './subViews/MyRequests/MyRequests';
import MyDocuments from './subViews/myDocuments/MyDocuments';

import MyInstitutionalDocuments from './subViews/myInstitutionalDocuments/MyInstitutionalDocuments';
import { useTranslation } from 'react-i18next';
import { getMetricsData } from '../../api/myDesk';
import { useQuery, useQueryClient } from 'react-query';

function MyDesk() {
  const [t, i18n] = useTranslation('desk');
  const matchesWidth = useMediaQuery('(min-width:768px)');
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [ActiveMenu, setActiveMenu] = useState(1); //0-MI PERFIL, 1-MIS SOLICITUDES,  2-MIS DOCUMENTOS,  3-OTROS 
  const [ActiveDocumentMenu, setActiveDocumentMenu] = useState(0); //0 DOCUMENTOS PERSONALES ,1 DOCUMENTOS INSTITUCIONALES

  const [openModifyProfileModal, setOpenModifyProfileModal] = useState(false);
  const [openModifyOrAddCompanyModal, setOpenModifyOrAddCompanyModal] =
    useState(false);
  const [selectedCompany, setSelectedCompany] = useState(false);

  const [openRequestDetailModal, setOpenRequestDetailModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState();

  const userData = queryClient.getQueryData(['userData']);
  const { data: metricsData, isLoading: metricsDataIsLoading } = useQuery(
    ['myDeskMetricsData'],
    () => getMetricsData(userData.payload.citizen_id),
    {
      enabled: userData?.payload?.citizen_id !== undefined,
    }
  );

  const handleChangeMenu = (menuID) => {
    setActiveMenu(menuID);
  };

  const handleChangeDocumentMenu = (menuID) => {
    setActiveDocumentMenu(menuID);
  };

  const handleRequestDetailModalStatus = (request) => {
    setSelectedRequest(request);
    setOpenRequestDetailModal(!openRequestDetailModal);
  };

  useLayoutEffect(() => {
    dispatch(UpdateAppSubHeaderTitle(t('My_desk'))); //SET SUBHEADER TITLE
  }, [i18n.language]);

  return (
    <Container>
      <Row>
        {matchesWidth && (
          <Fragment>
            <ServiceDirectoryMenu />
            <RowBodyDivider />
          </Fragment>
        )}
        <Container>
          <SmallHeightDivider />
          <CardContainer>
            <MetricsTextContainer>
              <MetricsTitle>{t('Requests_in_process')}</MetricsTitle>
              <MetricsValue>{metricsData?.reqsOpen}</MetricsValue>
            </MetricsTextContainer>
            <MetricsContentDivider />
            <MetricsTextContainer>
              <MetricsTitle>{t('Completed_requests')}</MetricsTitle>
              <MetricsValue>{metricsData?.reqsComplete}</MetricsValue>
            </MetricsTextContainer>
            <MetricsContentDivider />
            <MetricsTextContainer>
              <MetricsTitle>{t('Uploaded_documents')}</MetricsTitle>
              <MetricsValue>{metricsData?.documents}</MetricsValue>
            </MetricsTextContainer>
            <MetricsContentDivider />
            <MetricsTextContainer>
              <MetricsTitle>{t('Rejected_applications')}</MetricsTitle>
              <MetricsValue>{metricsData?.reqsRejected}</MetricsValue>
            </MetricsTextContainer>
          </CardContainer>

          <MediumHeightDivider />
          <ButtonsMenuContainer>
            <ButtonGroup size='large'>

              {/* MI PERFIL */}
              <StyledButtonOutlined
                active={ActiveMenu == 0}
                onClick={() => handleChangeMenu(0)} >
                {t('My_profile')}
              </StyledButtonOutlined>

              {/* MIS SOLICITUDES */}
              <StyledButtonOutlined
                active={ActiveMenu == 1}
                onClick={() => handleChangeMenu(1)}>
                {t('My_requests')}
              </StyledButtonOutlined>

              {/* DOCUMENTOS */}
              <StyledButtonOutlined
                active={ActiveMenu == 2}
                onClick={() => handleChangeMenu(2)}>
                {t('Documents')}
              </StyledButtonOutlined>

            </ButtonGroup>
          </ButtonsMenuContainer>

          {ActiveMenu == 0 ? ( // MI PERFIL
            <MyProfile />
          ) : ActiveMenu == 1 ? ( // SOLICITUDES EN PROCESO
            <MyRequests />
          ): (
                // DOCUMENTOS
                <Fragment>
                  <MediumHeightDivider />
                  <ButtonsMenuContainer>
                    <ButtonGroup size='large'>

                      <StyledButtonOutlined
                        active={ActiveDocumentMenu == 0}
                        onClick={() => handleChangeDocumentMenu(0)}>
                        {t('Personal_documents')}
                      </StyledButtonOutlined>

                      <StyledButtonOutlined
                        active={ActiveDocumentMenu == 1}
                        onClick={() => handleChangeDocumentMenu(1)} >
                        {t('Institutional_Documents')}
                      </StyledButtonOutlined>

                    </ButtonGroup>
                  </ButtonsMenuContainer>

                  {ActiveDocumentMenu == 0 ? (
                    <MyDocuments />
                  ) : (
                    <MyInstitutionalDocuments />
                  )}
                </Fragment>
              )}



        </Container>
      </Row>
    </Container>
  );
}

export default MyDesk;
